window.dataLayer = window.dataLayer || [];
window.gtag = function () { dataLayer.push(arguments); }

window.gaTracking = {

    init(scriptPath, propertyId, anonymizeIp) {
        this.propertyId = propertyId;
        gtag('js', new Date());
        gtag('config', propertyId, { 'anonymize_ip': anonymizeIp });
    },

    loadECommerce() {

    },

    addECommerceTransaction(id, affiliation, revenue, shipping, tax, items) {
        gtag('event', 'purchase', {
            "transaction_id": id,
            "affiliation": affiliation,
            "value": revenue,
            "tax": tax,
            "shipping": shipping,
            "items": items
        });
    },

    sendEcommerce() {

    },

    sendTiming() {
        const timeSincePageLoad = Math.round(performance.now());
        gtag('event', 'timing_complete', {
            'name': 'load',
            'value': timeSincePageLoad,
            'event_category': 'JS Dependencies'
        });
    },

    sendPageView(
        page_title = document.querySelector('title') ? document.querySelector('title').childNodes[0].nodeValue : null, 
        page_path = window.location.pathname,
    ) {
        gtag('config', this.propertyId, {
            'page_title': page_title,
            'page_path': page_path
        });

        if (window.laravelDebug) {
            console.log("Page view sent", { propertyId: this.propertyId, page_path, page_title });
        }
    },

    sendEvent(category, action, label, value = null) {
        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value
        });

        if (window.laravelDebug) {
            console.log("Event sent", { category, action, label, value });
        }
    },

};



// WEBPACK FOOTER //
// ./resources/js/frontend/tracking_ga_gtag.js